import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { ShowExpanded } from '../shared';
import ActionItem from './ActionItem';

@observer
class MainArea extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }
  render() {
    const { mainArea, actions } = this.props;
    const { expanded } = this.state;
    let actionList = null;

    if (expanded) {
      actionList = (
        <div className="list-group">
          {actions.map(action => (
            <ActionItem key={action.actCode} action={action} />
          ))}
        </div>
      );
    }

    return (
      <div className="list-group-item">
        <span className="badge">{actions.length}</span>
        <div onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          {mainArea}
        </div>
        {actionList}
      </div>
    );
  }
}

export default MainArea;



// WEBPACK FOOTER //
// ./src/actions/MainArea.js